import React from 'react';
import NewCountry from './NewCountry';

const AddCountry = () => {
    return (
        <NewCountry></NewCountry>
    )
}

export default AddCountry